var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.08081 18V16M12.0808 18V15M17.0808 18V13M2.58081 12C2.58081 7.52166 2.58081 5.28249 3.97205 3.89124C5.3633 2.5 7.60247 2.5 12.0808 2.5C16.5591 2.5 18.7983 2.5 20.1896 3.89124C21.5808 5.28249 21.5808 7.52166 21.5808 12C21.5808 16.4783 21.5808 18.7175 20.1896 20.1088C18.7983 21.5 16.5591 21.5 12.0808 21.5C7.60247 21.5 5.3633 21.5 3.97205 20.1088C2.58081 18.7175 2.58081 16.4783 2.58081 12Z",
    stroke: "#656F7D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.073 11.4863C8.2281 11.5581 13.1149 11.2328 15.8945 6.82132M14.0731 6.28835L15.9486 5.98649C16.1772 5.95738 16.5128 6.13785 16.5953 6.35298L17.0912 7.99142",
    stroke: "#656F7D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysis);
export default __webpack_public_path__ + "static/media/analysis.d6ccbcd5ceb187a96adf3b32bc93b44f.svg";
export { ForwardRef as ReactComponent };